<template>
	<card type="cinc" class="ReCardServiceAdd lightTheme" 
	v-loading.fullscreen.lock="$GVO.fullscreenLoading"
	element-loading-text="Загрузка данных..."
	element-loading-spinner="el-icon-loading"
	element-loading-background="rgba(0, 0, 0, 0.8)"	
	
	>
		<div ><h5 @click="showForm()" class="btn btn-primary btn-simple mr-2 mt-0"><!--i class="tim-icons icon-simple-add mr-1"></i-->Добавить услугу</h5>  
			<el-tooltip content="Сохранить текущие настройки как 'Мой шаблон'" placement="top" v-if="bShowForm">
				<base-button class="btn btn-icon btn-simple btn-primary mb-0" @click="saveLocalSettings"> <i class="tmplt-icon"></i> </base-button> 
			</el-tooltip>
		</div>

		<div class="mt-3" v-show="bShowForm">		
			<ReFormPrinter 
				:masFormConfig="masAllFormParams" 
				:objSaveApiMethod="currentApiFormMethod"		
				:SuccessGo="SuccessGo"
				SuccessBtnText="Добавить"/>
		</div>
	</card>
</template>

<script>
	import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
	import { Tooltip } from 'element-ui';
	import filterParam from 'src/mixins/filterParam.js';

	export default {
		name: 'ReCardServiceAdd',
		mixins: [filterParam],
		components: {
			ReFormPrinter,
			[Tooltip.name]: Tooltip,
		},
		props: {
			objClient: Object,
			findId: {
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				currentApiFormMethod: this.currentApiFormMethodComp(),
				masAllFormParams: this.currentFormConfig(),
				bShowForm: false,
				fullscreenLoading: false,
			}
		},
		computed: {
			storageName(){
				return 'service-add-data';
			}
		},
		methods: {

			saveLocalSettings(){
				// mixins/filterParam
				this.objCacheOpts = this.buildCacheFilter(this.masAllFormParams);
				localStorage.setItem(this.storageName,JSON.stringify(this.objCacheOpts));
			},
			loadLocalSettings(){
				try{
					let params=localStorage.getItem(this.storageName);
					params=JSON.parse(params);
					if(params){
						// mixins/filterParam
						this.SetFilterParams(this.masAllFormParams, params);
					}
				}catch(e){
					console.error(e);
				}
			},					
			currentApiFormMethodComp(){
				return {apiMethod:'INS',apiParam:{obj:'services' ,flt:{client_id:this.objClient.id},iData:[]}};
			},
			currentFormConfig(){
				this.$GVO.ApiCall('GET_FORM',{obj:'services',flt:{client_id:this.objClient.id,only_act:true}})
					.then((objApi) => {
						//console.log(objApi);
						if(objApi.success){
							this.masAllFormParams = objApi.config;
							this.loadLocalSettings();
						}
					})
					.catch(errorObjApi => console.error(errorObjApi));
				return [];
			},
			SuccessGo(evt){
				location.reload(); //надо поменять на что-то другое
				return true;
			},
			showForm() {
				this.bShowForm = !this.bShowForm;
			},
			openFullScreen1(){
				this.fullscreenLoading = true;
				setTimeout(() => {
				this.fullscreenLoading = false;
				}, 2000);
			},
		},
	}
</script>
<style scoped>
.white-content .card:not(.card-white) .lightTheme {background: #f1f6fc!important; box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25)!important; border: 1px solid #9e77f3;}
.ReCardServiceAdd { border: 1px solid #9e77f3;}
.ReCardServiceAdd h5 {color: #01b0e0; margin-bottom: 0;}
.ReCardServiceAdd .select-primary.el-select .el-input input::placeholder {color: rgb(230, 21, 21)!important; opacity: 1;}
.ReCardServiceAdd .form-options-group .row {margin-bottom: 10px;}
.ReCardServiceAdd >>> .ReInputSearchDrop {width: 100%;}
.ReCardServiceAdd >>> .add-btn {cursor: pointer;}
.ReCardServiceAdd >>> .tmplt-icon {
width: 18px;
height: 18px;
display: inline-block;
background: url('/img/icons/savefile.svg') no-repeat; 
}

</style>
